/**
 * OpeningHours Component
 *
 * Displays business opening hours information.
 * Features:
 * - Two-column layout: Image side (desktop) and Hours side
 * - Background image with overlay on hours side
 * - Badge overlay on image side
 * - Opening hours badge/schedule image
 * - Responsive: Single column on mobile, two columns on desktop
 */

import { Image } from "@heroui/image";

import Badge from "./modules/home/Badge";
import Separator from "./Separator";

const OpeningHours = () => {
  return (
    <section className="flex bg-primary h-[60vh] xl:h-[80vh] overflow-hidden">
      {/* Left Side - Image with Badge Overlay (Hidden on mobile, visible on xl) */}
      <div className="hidden relative xl:flex flex-1 justify-center items-center">
        {/* Dark Overlay - 60% opacity for contrast */}
        <div className="w-full h-full absolute z-40 top-0 bg-black/60 pointer-events-none" />
        {/* Background Image */}
        <Image
          isZoomed // Añade un efecto sutil al pasar el mouse
          removeWrapper // Permite que la imagen llene el contenedor relativo padre
          alt=""
          className="absolute inset-0 z-0 w-full h-full object-cover"
          src="/assets/opening-hours/img.png"
        />
        {/* Badge Overlay - Centered over image */}
        <Badge containerStyles="w-[320px] h-80 absolute z-20" />
      </div>

      {/* Right Side - Opening Hours Content */}
      <div className="flex-1 bg-opening_hours bg-cover bg-no-repeat flex flex-col justify-center items-center relative">
        {/* Dark Overlay - 85% opacity for text readability */}
        <div className="w-full h-full absolute top-0 bg-black/85 z-10" />

        {/* Content Container */}
        <div className="z-20 flex flex-col items-center justify-center">
          {/* Section Title */}
          <h2 className="h2 text-white mb-4">Opening Hours</h2>

          {/* Decorative Separator */}
          <Separator bg="accent" />

          {/* Opening Hours Badge/Schedule Image */}
          {/* Responsive sizing: 300x220 on mobile, 470x280 on desktop */}
          <div className="mt-12 relative">
            <Image
              alt="Schedule schedule"
              className="object-contain w-75 h-55 xl:w-117.5 xl:h-70"
              fallbackSrc="https://via.placeholder.com/470x280"
              height={280}
              src="/assets/opening-hours/program-badge.svg"
              width={470}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpeningHours;
